import { render } from "./companyUsers.vue?vue&type=template&id=6d7b98da&ts=true"
import script from "./companyUsers.vue?vue&type=script&lang=ts"
export * from "./companyUsers.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__